import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getLogin = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/user/login`, {params});
};

export {
    getLogin
}